(() => {
  const TOTAL   = 1800;
  const PATHS   = {
    L: ['|','I','1','Γ','L'],
    X: ['×','+','✕','Ж','X'],
    '3': ['8','E','ε','Ξ','3'],
  };

  function organicT(t, phase, speed) {
    return Math.sin(t * speed + phase) * 0.6
         + Math.sin(t * speed * 1.7 + phase * 0.5) * 0.4;
  }

  function animateTitle(h1) {
    const text = h1.textContent.trim();
    h1.innerHTML = '';

    const spans = [...text].map(ch => {
      const s = document.createElement('span');
      s.className = 'pta-char';
      s.textContent = ch;
      h1.appendChild(s);
      const path = PATHS[ch] || null;
      return {
        el: s, char: ch, path,
        pathIdx: 0,
        resolved: !path,
        swapInterval: 90 + Math.random() * 80,
        lastSwap: 0,
        phase: Math.random() * Math.PI * 2,
        speed: 1.8 + Math.random() * 1.4,
        resolveAt: null,
      };
    });

    // Stagger resolve times for animated chars
    const animated = spans.filter(s => s.path);
    animated.forEach((s, i) => {
      s.resolveAt = 0.25 + (i / animated.length) * 0.55
                  + (Math.random() * 0.08 - 0.04);
    });

    spans.forEach(s => {
      if (!s.path) s.el.classList.add('pta-resolved');
    });

    // Trigger CSS fade-in
    void h1.offsetWidth;
    h1.classList.add('pta-play');

    const start = performance.now();

    const tick = (now) => {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / TOTAL, 1);
      const t        = elapsed / 1000;

      spans.forEach(s => {
        if (s.resolved) return;

        if (progress >= s.resolveAt) {
          s.resolved = true;
          s.el.textContent = s.char;
          s.el.classList.add('pta-resolved');
          // Snap ease-out: glide from slightly below
          s.el.style.transform = 'translateY(6px)';
          s.el.style.opacity   = '0.4';
          requestAnimationFrame(() => {
            s.el.style.transform = '';
            s.el.style.opacity   = '';
          });
          return;
        }

        const charP = progress / s.resolveAt;
        const calm  = 1 - charP * charP;

        if (now - s.lastSwap >= s.swapInterval) {
          s.lastSwap = now;
          s.pathIdx  = Math.min(
            Math.floor(charP * (s.path.length - 1)),
            s.path.length - 2
          );
          if (Math.random() < 0.25 && s.pathIdx > 0) s.pathIdx--;
          s.el.textContent = s.path[s.pathIdx];
        }

        const dy    = organicT(t, s.phase, s.speed) * 10 * calm;
        const dx    = organicT(t, s.phase + 2, s.speed * 0.6) * 3 * calm;
        const scale = 1 + organicT(t, s.phase + 1, s.speed * 1.2) * 0.07 * calm;
        const op    = 0.45 + 0.55 * Math.abs(organicT(t, s.phase, s.speed * 0.9));

        s.el.style.transform = `translate(${dx.toFixed(2)}px,${dy.toFixed(2)}px) scale(${scale.toFixed(4)})`;
        s.el.style.opacity   = Math.min(op, 1).toFixed(3);
      });

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        spans.forEach(s => {
          s.el.textContent = s.char;
          s.el.classList.add('pta-resolved');
          s.el.style.cssText = '';
        });
      }
    };

    requestAnimationFrame(tick);
  }

  function init() {
    const h1 = document.querySelector('.product__title h1');
    if (!h1 || h1.hasAttribute('data-title-anim')) return;
    h1.setAttribute('data-title-anim', '');
    animateTitle(h1);
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live reload
  document.addEventListener('shopify:section:load', init);
})();
